import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingPhotoFileExtensionTypes = union([literal("jpg"), literal("jpeg"), literal("png"), literal("JPG"), literal("JPEG"), literal("PNG")]);

export type TListingPhotoFileExtensionTypes = TTypeOfCodec<typeof ListingPhotoFileExtensionTypes>;
